<template>
  <entity-list-table
    title="Коннекторы"
    :data-service="dataService"
    :headers="headers"
    create-route-name="connector-create"
    edit-route-name="connector-edit"
    allow-delete
    :show-status-column="false"
  >
    <template #item.source="{item}">
      {{ item.source.name }}
    </template>
  </entity-list-table>
</template>

<script>
  import EntityListTable from '@/components/ui/crud/EntityListTable.vue'
  import ConnectorDataService from '@/services/api/ConnectorDataService'

  export default {
    name: 'ConnectorList',
    components: { EntityListTable },
    data () {
      return {
        dataService: ConnectorDataService,
        headers: [
          { text: 'ID', value: 'id', align: 'center' },
          { text: 'Название', value: 'name', align: 'start' },
          { text: 'Тип', value: 'typeName', align: 'center' },
          { text: 'Источник', value: 'source', align: 'start', sortable: false },
        ],
      }
    },
  }
</script>
